<template>
    <div
      class="input-table"
      v-if="loaded"
    >
        <div
            v-for="(item, index) in items"
            class="input-table-shadow"
            :key="index + item.id + reloadCount"
        >
            <div class="d-flex row align-items-center">
                <div class="col-4 border-right">
                    <input class="pl-3" type="text" readonly="readonly" :value="item.name" />
                </div>
                <div class="col border-right">
                    <core-money-input readonly="readonly" :key='item.key' :amount.sync="item.purchasePrice"></core-money-input>
                </div>
                <div class="col border-right">
                  <core-money-input v-on:update:amount="priceChanged($event, item)" :amount.sync="item.customPrice"></core-money-input>
                </div>
                <div class="col border-right">
                    <input class="pl-3" @change="amountChanged($event, item)" type="text" v-model="item.amount" />
                </div>
                <div class="col">
                    <core-money-input :key="subTotal(item)" readonly :amount="subTotal(item)"></core-money-input>
                </div>
            </div>
        </div>
      </div>
      <div v-else>
          <small class="ml-2 px-2 bg-danger text-white">Geen transport gevonden voor deze periode</small>
      </div>
</template>

<script>
import Price from '@/services/hatsApi/Price'
import Service from '@/services/hatsApi/Service'

export default {
  props: {
    service: {
      type: Object,
      required: true
    },
    selectedTypes: {
      default: () => ([]),
      type: Array,
      required: false
    },
    outbound: {
      default: '',
      type: Number | Boolean,
      required: false
    },
    reservationId: {
      default: '',
      type: Number | String,
      required: false
    },
    departureDate: {
      default: null,
      type: String,
      required: false
    },
    selectedClass: {
      type: String | Number,
      required: false
    },
    selectedRoomsAmount: {
      type: String | Number,
      required: false
    },
    dataIsFilling: {
      type: Boolean,
      required: false
    },
    travelers: {
      default: () => ([]),
      type: Array,
      required: false
    }
  },
  data () {
    return {
      items: [],
      loaded: false,
      selectedAvailability: 0,
      reloadCount: 0
    }
  },
  created () {
    this.loadTypes()
  },
  methods: {
    calculatedPurchasePrice (item) {
      let koeff = 1
      if (this.service && this.service.commission) {
        koeff = 1 - (this.service.commission / 100)
      }
      item.purchasePrice = item.customPrice ? item.customPrice * koeff : item.purchasePrice
      return item.purchasePrice
    },
    async loadTypes () {
      try {
        let filters = [
          {
            property: 'serviceIdParent',
            value: parseInt(this.service.id)
          }
        ]
        let response = await Service.getServices(filters, 0, 0, this.reservationId)
        if (response.data.success) {
          response.data.data.forEach(item => {
            if (item.customPrice) {
              item.purchasePrice = this.calculatedPurchasePrice(item)
            }
            item.key = 0
          })
          this.items = response.data.data
          if (this.dataIsFilling) {
            let selected = false
            let cnt = this.travelers.length ? this.travelers.length : 1
            this.items.forEach(item => {
              if (!selected && item.default) {
                this.$set(item, 'amount', cnt)
                this.amountChanged(null, item, cnt)
                selected = true
              }
            })
            if (!selected) {
              this.items.forEach(item => {
                if (!selected) {
                  this.$set(item, 'amount', cnt)
                  this.amountChanged(null, item, cnt)
                  selected = true
                }
              })
            }
            this.$emit('occupancyLoaded', true)
          }
          let basePrices = this.loadBasePrices()
          Promise.all(basePrices).then(() => {
            this.reloadCount += 1
            this.setSelectedAmount()
            this.loaded = true
          })
        }
      } catch (e) {
        console.error(e)
      }
    },
    loadBasePrices () {
      let promises = []
      if (this.items.length) {
        this.items.forEach((item) => {
          let existingItem = false
          let isSelected = false
          // Check if we have a custom price set, before going to the default price
          this.selectedTypes.forEach((selected) => {
            if (selected.service.id === item.id) {
              isSelected = true
            }
            existingItem = this.$_.find(this.items, { 'id': selected.service.id + '' })
          })
          if (!isSelected && item.price) {
            this.$set(item, 'customPrice', item.price)
            this.$set(item, 'purchasePrice', item.price)
          }
          if (!existingItem || !this.selectedTypes.length) {
            let filter = [
              {
                property: 'serviceId',
                value: item.id
              },
              {
                property: 'date',
                value: this.departureDate
              }
            ]

            if (this.outbound !== '') {
              filter.push({
                property: 'outbound',
                value: Boolean(this.outbound)
              })
            }

            promises.push(Price.getBasePrices(filter).then((response) => {
              if (response.data.success && response.data.data.length) {
                let salePrice = parseInt(response.data.data[0].salePrice)
                if (!salePrice) {
                  salePrice = parseInt(item.salePrice ? item.salePrice : item.price)
                }
                let purchasePrice = parseInt(response.data.data[0].purchasePrice)
                if (!purchasePrice) {
                  purchasePrice = parseInt(item.purchasePrice ? item.purchasePrice : item.price)
                }
                this.$set(item, 'salePrice', salePrice)
                if (salePrice && !item.customPrice) {
                  this.$set(item, 'customPrice', salePrice)
                }
                this.$set(item, 'purchasePrice', purchasePrice)
                this.$set(item, 'amount', 0)
              }
            }))
          }
        })
      }
      return promises
    },
    setSelectedAmount () {
      if (this.selectedTypes.length) {
        this.selectedTypes.forEach((selected) => {
          let item = this.$_.find(this.items, { 'id': selected.service.id + '' })
          if (item) {
            this.$set(item, 'customPrice', parseInt(selected.customPrice))
            this.$set(item, 'purchasePrice', parseInt(selected.purchasePrice))
            this.$set(item, 'amount', parseInt(selected.amount))
          }
        })
      }
    },
    subTotal (transportType) {
      let amount = 0
      if (transportType.priceType.code !== 'PERSERVICE') {
        amount = transportType.amount * transportType.customPrice
      } else {
        amount = transportType.amount * transportType.customPrice // temporary fix that can cause a new bug :)
      }
      return amount
    },
    amountChanged (evt, item, amount) {
      setTimeout(() => {
        const cloneItem = Object.assign({}, item)
        cloneItem.amount = amount || evt.target.value
        this.$emit('amountChanged', this.items, cloneItem)
      }, 100)
    },
    priceChanged (val, item) {
      if (val) {
        setTimeout(() => {
          item.customPrice = val
          item.purchasePrice = this.calculatedPurchasePrice(item)
          item.key++
          this.$emit('amountChanged', this.items, item)
        }, 100)
      }
    }
  },
  watch: {
    items: {
      handler (val) {
        this.$emit('amountChanged', val)
      },
      deep: true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/reservation/details/FreeSaleServiceType.vue